import { createFileRoute } from "@tanstack/react-router";
import GeneratorBrowse from "@/pages/GeneratorBrowse";

export const Route = createFileRoute("/generators/brand/$filterValue")({
  component: GeneratorBrowse,
});
